import { Text } from '@cinch-labs/design-system'

interface GapOptOutResultProps {
  mainBody: string
  children?: React.ReactNode | undefined
}

export const GapOptOutResult: React.FC<GapOptOutResultProps> = ({
  mainBody,
  children,
}) => (
  <>
    <Text fontSizeFixed={'l'}>{mainBody}</Text>
    {children}
  </>
)
